/**
 * @param {string} url
 * @param {object} formParams
 */
export default function buildAndSubmitForm(url, formParams = {}) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    Object.entries(formParams).forEach(([name, value]) => {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = name;
        hiddenField.value = value;
        form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();
}
